import { IButton } from 'common/builder/buttons/buttonInterfaces'
import { isUrlButton as getIsUrlButton } from 'common/builder/buttons/buttonTypeHelpers'
import { NodeType } from 'common/builder/constants/NodeType'
import { getParentNode } from 'common/builder/selectors/builder/entitySelectors'

export const getIsMessageTemplateUrlButton = (
  entity: IButton,
  builderId: string,
  state: RootState,
): boolean => {
  const isUrlButton = getIsUrlButton(entity)

  if (!isUrlButton) {
    return false
  }

  const parentNode = getParentNode(state, builderId, entity.id)

  return (
    parentNode !== undefined &&
    parentNode.nodeType === NodeType.WHATS_APP &&
    parentNode.whatsAppNodeType === 'template'
  )
}
